import { render, staticRenderFns } from "./SwitchQuestion.vue?vue&type=template&id=3f98570b&scoped=true"
import script from "./SwitchQuestion.vue?vue&type=script&lang=js"
export * from "./SwitchQuestion.vue?vue&type=script&lang=js"
import style0 from "./SwitchQuestion.vue?vue&type=style&index=0&id=3f98570b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f98570b",
  null
  
)

export default component.exports